// extracted by mini-css-extract-plugin
export default {"container":"hotelCardFeatures-module__container__KbGKR","scroll":"hotelCardFeatures-module__scroll__Elh7I","mobileContainer":"hotelCardFeatures-module__mobileContainer__8+sJ0"};